// extracted by mini-css-extract-plugin
export var hr = "pagination-module--hr--6d9d0";
export var next = "pagination-module--next--92e1f";
export var prev = "pagination-module--prev--c84d2";
export var root = "pagination-module--root--2fdea";